/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject, Input, OnChanges, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DxTreeViewComponent, DxTreeViewModule } from 'devextreme-angular';
import { Item as TreeViewItem } from 'devextreme/ui/tree_view';
import { DocumentConfigSearchDisplay } from '../../../distribution/models';
import { ContentTypeGroup } from '../../../distribution/models/content-type-group';
import { InitStep } from '../../../distribution/models/init-step';
import { IdentificationType, IdentificationTypeQualifier } from '../../../partner/models';
import { ScheduleItem, Trigger } from '../../../shared/scheduling/models';
import { DuplicateCheckTypeEntity } from '../../../tracking/models/duplicate-check-type';
import { TransportType } from '../../../transport/models/transport-type';
import {
    AssemblyArtifactNode,
    BatchingConfigurationNode,
    ConfigKeyNode,
    ContentTypeGroupNode,
    DataMapper,
    DistroNode,
    DocConfigNode,
    DocumentTypeClassifierNode,
    DocumentTypeClassifierResolverNode,
    DuplicateCheckNode,
    ExceptionTypeNode,
    FileNamingTypeNode,
    InitializeStepNode,
    ItineraryStepNode,
    IdentificationTypeNode,
    TrackingFieldNode,
    TransportTypeNode,
    XmlArtifactNode,
    XmlPropertyPromotionFilterNode
} from '../../helpers/export-node';
import { AssemblyArtifact, XmlArtifact } from '../../models/artifact';
import { BatchingConfiguration } from '../../models/batchconfiguration';
import { ConcurrencyKey } from '../../../configuration/models/concurrency-key';
import { ConfigurationKey } from '../../models/configuration-key';
import { ConfigurationKeyUsage } from '../../models/configuration-key-usage';
import { DocumentTypeDeveloper } from '../../models/document-type';
import { DocumentConfigOutBatcher } from '../../models/document-config-out-batcher';
import { DocumentTypeClassifier } from '../../models/document-type-classifier';
import { DocumentTypeClassifierResolverEntity } from '../../models/document-type-classifier-resolver';
import { ExceptionType } from '../../models/exception-type';
import { ExportItems } from '../../models/exportItems';
import { FileNamingType } from '../../models/filenamingtype';
import { Format } from '../../models/format';
import { FormatType } from '../../models/format-type';
import { ItineraryStep } from '../../models/itinerary';
import { ItineraryStepDocumentConfigEntity } from '../../models/itinerary-step-document-config-entity';
import { TrackingField } from '../../models/tracking-field';
import { Variant } from '../../models/variant';
import { VariantVersion } from '../../models/variant-version';
import { XmlPropertyPromotionFilter } from '../../models/xml-property-promotion-filter';
import { GenericModalService } from 'src/app/shared/generic-modal/generic-modal.service';

@Component({
    selector: 'app-developer-export-dbview',
    templateUrl: './developer-export-dbview.component.html',
    styleUrls: ['./developer-export-dbview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxTreeViewModule]
})
export class DeveloperExportDbviewComponent implements OnChanges, DataMapper {
    private modalService = inject(GenericModalService);

    @ViewChild(DxTreeViewComponent) treeView: DxTreeViewComponent;

    @Input() formatTypes: FormatType[] = [];
    @Input() formats: Format[] = [];
    @Input() variants: Variant[] = [];
    @Input() versions: VariantVersion[] = [];
    @Input() distros: DocumentTypeDeveloper[] = [];
    @Input() docConfigs: DocumentConfigSearchDisplay[] = [];
    @Input() trackingFields: TrackingField[];
    @Input() configKeys: ConfigurationKey[];
    @Input() exceptions: ExceptionType[];
    @Input() configKeyUsage: ConfigurationKeyUsage[];
    @Input() itinerarySteps: ItineraryStep[];
    @Input() initializeSteps: InitStep[];
    @Input() transportTypes: TransportType[];
    @Input() xmlArtifacts: XmlArtifact[];
    @Input() assemblyArtifacts: AssemblyArtifact[];
    @Input() fileNamingTypes: FileNamingType[];
    @Input() documentConfigItinerarySteps: ItineraryStepDocumentConfigEntity[];
    @Input() promotionFilters: XmlPropertyPromotionFilter[];
    @Input() duplicateChecks: DuplicateCheckTypeEntity[];
    @Input() contentTypeGroups: ContentTypeGroup[];
    @Input() documentTypeClassifierResolvers: DocumentTypeClassifierResolverEntity[];
    @Input() documentTypeClassifiers: DocumentTypeClassifier[];
    @Input() batchingConfigurations: BatchingConfiguration[];
    @Input() scheduleItems: ScheduleItem[];
    @Input() scheduleTriggers: Trigger[];
    @Input() documentConfigOutBatchers: DocumentConfigOutBatcher[];
    @Input() identificationTypes: IdentificationType[];
    @Input() identificationTypeQualifiers: IdentificationTypeQualifier[];
    @Input() concurrencyKeys: ConcurrencyKey[];

    selectedNodeCount = 0;
    private selectedNodeKeys: number[] = [];

    rootConfigKeys: TreeViewItem = { text: 'Configuration keys', items: [] };
    rootDocConfigs: TreeViewItem = { text: 'Document configurations', items: [] };
    rootDocTypes: TreeViewItem = { text: 'Document types', items: [] };
    rootErrorCodes: TreeViewItem = { text: 'Error codes', items: [] };
    rootItinerarySteps: TreeViewItem = { text: 'Itinerary steps', items: [] };
    rootInitializeSteps: TreeViewItem = { text: 'Initialize steps', items: [] };
    rootTransportTypes: TreeViewItem = { text: 'Transport types', items: [] };
    rootTrackFields: TreeViewItem = { text: 'Tracking fields', items: [] };
    rootFileNamingTypes: TreeViewItem = { text: 'File naming types (File naming types linked to a document type will not be shown here)', items: [] };
    rootAssemblyArtifacts: TreeViewItem = { text: 'Assembly artifacts', items: [] };
    rootXmlArtifacts: TreeViewItem = { text: 'Xml artifacts', items: [] };
    rootPromotionFilters: TreeViewItem = { text: 'Xml property promotions', items: [] };
    rootDuplicateChecks: TreeViewItem = { text: 'Duplicate checks', items: [] };
    rootContentTypeGroups: TreeViewItem = { text: 'Content type groups', items: [] };
    rootDocumentTypeClassifierResolvers: TreeViewItem = { text: 'Document type classifier resolvers', items: [] };
    rootDocumentTypeClassifiers: TreeViewItem = { text: 'Document type classifiers', items: [] };
    rootBatchingConfigurations: TreeViewItem = { text: 'Batching configurations', items: [] };
    rootIdentificationTypes: TreeViewItem = { text: 'Identification types', items: [] };
    rootNodes: TreeViewItem[] = [
        this.rootConfigKeys,
        this.rootDocConfigs,
        this.rootDocTypes,
        this.rootErrorCodes,
        this.rootItinerarySteps,
        this.rootInitializeSteps,
        this.rootTransportTypes,
        this.rootTrackFields,
        this.rootFileNamingTypes,
        this.rootAssemblyArtifacts,
        this.rootXmlArtifacts,
        this.rootPromotionFilters,
        this.rootDuplicateChecks,
        this.rootContentTypeGroups,
        this.rootDocumentTypeClassifierResolvers,
        this.rootDocumentTypeClassifiers,
        this.rootBatchingConfigurations,
        this.rootIdentificationTypes
    ].sort((a, b) => a.text.localeCompare(b.text));

    ngOnChanges(changes: SimpleChanges): void {
        try {
            // The order of these calls is important. Entities must come after entities
            // that they reference, ie. tracking fields after distribution objects.
            if (changes.distros) {
                this.rootDocTypes.items = (changes.distros.currentValue as DocumentTypeDeveloper[])
                    .map(item => new DistroNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.docConfigs) {
                this.rootDocConfigs.items = (changes.docConfigs.currentValue as DocumentConfigSearchDisplay[])
                    .map(item => new DocConfigNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.trackingFields) {
                this.rootTrackFields.items = (changes.trackingFields.currentValue as TrackingField[])
                    .map(item => new TrackingFieldNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.configKeys) {
                if (this.configKeyUsage.length !== 0) {
                    this.rootConfigKeys.items = (changes.configKeys.currentValue as ConfigurationKey[])
                        .map(item => new ConfigKeyNode(item, this, this.configKeyUsage).treeViewItem)
                        .sort((a, b) => a.text.localeCompare(b.text));
                }
            }
            if (changes.itinerarySteps) {
                this.rootItinerarySteps.items = (changes.itinerarySteps.currentValue as ItineraryStep[])
                    .map(item => new ItineraryStepNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.initializeSteps) {
                this.rootInitializeSteps.items = (changes.initializeSteps.currentValue as InitStep[])
                    .map(item => new InitializeStepNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.transportTypes) {
                this.rootTransportTypes.items = (changes.transportTypes.currentValue as TransportType[])
                    .map(item => new TransportTypeNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.exceptions) {
                this.rootErrorCodes.items = (changes.exceptions.currentValue as ExceptionType[])
                    .map(item => new ExceptionTypeNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.fileNamingTypes) {
                this.rootFileNamingTypes.items = (changes.fileNamingTypes.currentValue as FileNamingType[])
                    .map(item => new FileNamingTypeNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.xmlArtifacts) {
                this.rootXmlArtifacts.items = (changes.xmlArtifacts.currentValue as XmlArtifact[])
                    .map(item => new XmlArtifactNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.assemblyArtifacts) {
                this.rootAssemblyArtifacts.items = (changes.assemblyArtifacts.currentValue as AssemblyArtifact[])
                    .map(item => new AssemblyArtifactNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.promotionFilters) {
                this.rootPromotionFilters.items = (changes.promotionFilters.currentValue as XmlPropertyPromotionFilter[])
                    .map(item => new XmlPropertyPromotionFilterNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.duplicateChecks) {
                this.rootDuplicateChecks.items = (changes.duplicateChecks.currentValue as DuplicateCheckTypeEntity[])
                    .map(item => new DuplicateCheckNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.contentTypeGroups) {
                this.rootContentTypeGroups.items = (changes.contentTypeGroups.currentValue as ContentTypeGroup[])
                    .map(item => new ContentTypeGroupNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.documentTypeClassifierResolvers) {
                this.rootDocumentTypeClassifierResolvers.items = (changes.documentTypeClassifierResolvers.currentValue as DocumentTypeClassifierResolverEntity[])
                    .map(item => new DocumentTypeClassifierResolverNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.documentTypeClassifiers) {
                this.rootDocumentTypeClassifiers.items = (changes.documentTypeClassifiers.currentValue as DocumentTypeClassifier[])
                    .map(item => new DocumentTypeClassifierNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.batchingConfigurations) {
                this.rootBatchingConfigurations.items = (changes.batchingConfigurations.currentValue as BatchingConfiguration[])
                    .map(item => new BatchingConfigurationNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (changes.identificationTypes) {
                this.rootIdentificationTypes.items = (changes.identificationTypes.currentValue as IdentificationType[])
                    .map(item => new IdentificationTypeNode(item, this).treeViewItem)
                    .sort((a, b) => a.text.localeCompare(b.text));
            }
            if (this.treeView) {
                this.treeView.items = null;
                this.treeView.items = this.rootNodes;
                this.updateSelectedNodes();
            }
        }
        catch (error: unknown) {
            if (error instanceof Error) {
                void this.modalService.messageDirect('An error occurred', error.message);
            }
            console.error('Error in DeveloperExportDbviewComponent.ngOnChanges:', error);
        }
    }

    mapDistro(id: number): DocumentTypeDeveloper {
        return this.distros.find(e => e.Id === id);
    }

    mapFormatType(id: number): FormatType {
        return this.formatTypes.find(e => e.Id === id);
    }

    mapFormat(id: number): Format {
        return this.formats.find(e => e.FormatsId === id);
    }

    mapVariant(id: number): Variant {
        return this.variants.find(e => e.VariantsId === id);
    }

    mapVersion(id: number): VariantVersion {
        return this.versions.find(e => e.VariantVersionsId === id);
    }

    mapItineraryStep(id: number): ItineraryStep {
        return this.itinerarySteps.find(e => e.Id === id);
    }
    mapInitializeStep(id: number): InitStep {
        return this.initializeSteps.find(e => e.Id === id);
    }
    mapTransportType(id: number): TransportType {
        return this.transportTypes.find(e => e.Id === id);
    }
    mapDocConfig(id: number): DocumentConfigSearchDisplay {
        return this.docConfigs.find(e => e.DocumentConfigId === id);
    }
    mapAssemblyArtifact(id: string): AssemblyArtifact {
        return this.assemblyArtifacts.find(e => e.ArtifactId === id);
    }
    mapXmlArtifact(id: string): XmlArtifact {
        return this.xmlArtifacts.find(e => e.ArtifactId === id);
    }
    mapFileNamingType(id: number): FileNamingType {
        return this.fileNamingTypes.find(e => e.FilenamingTypesId === id);
    }
    mapDocumentConfigItinerarySteps(DocumentConfigId: number): ItineraryStep[] {
        const connections = this.documentConfigItinerarySteps.filter(dcis => dcis.DocumentConfigId === DocumentConfigId).map(dcis => dcis.ItineraryStepId);
        return this.itinerarySteps.filter(is => connections.includes(is.Id));
    }
    mapDocumentConfigItineraryStepConfigs(DocumentConfigId: number): ItineraryStepDocumentConfigEntity[] {
        return this.documentConfigItinerarySteps.filter(dcis => dcis.DocumentConfigId === DocumentConfigId);
    }
    mapPromotionFilter(id: number): XmlPropertyPromotionFilter {
        return this.promotionFilters.find(e => e.Id === id);
    }
    mapDuplicateChecks(id: number): DuplicateCheckTypeEntity {
        return this.duplicateChecks.find(e => e.Id === id);
    }
    mapContentTypeGroups(id: number): ContentTypeGroup {
        return this.contentTypeGroups.find(e => e.Id === id);
    }
    mapDocumentTypeClassifierResolver(id: number): DocumentTypeClassifierResolverEntity {
        return this.documentTypeClassifierResolvers.find(e => e.Id === id);
    }
    mapDocumentTypeClassifiers(id: number): DocumentTypeClassifier {
        return this.documentTypeClassifiers.find(e => e.Id === id);
    }
    mapBatchingConfigurations(id: number): BatchingConfiguration {
        return this.batchingConfigurations.find(e => e.Id === id);
    }
    mapScheduleItems(id: number): ScheduleItem {
        return this.scheduleItems.find(e => e.Id === id);
    }
    mapScheduleTriggers(id: number): Trigger {
        return this.scheduleTriggers.find(e => e.Id === id);
    }
    mapDocumentConfigOutBatchers(docConfigId: number): DocumentConfigOutBatcher[] {
        return this.documentConfigOutBatchers.filter(e => e.DocumentConfigId === docConfigId);
    }
    mapIdentificationTypes(idType: number): IdentificationType[] {
        return this.identificationTypes.filter(e => e.IdentificationTypeId === idType);
    }

    mapConfigurationKeys(dynamicForeignKey: number, keyUsageName: string): ConfigurationKey[] {
        if (!this.configKeys?.length || !this.configKeyUsage?.length) return [];
    
        const usage = this.configKeyUsage.find(u => u.KeyUsageName === keyUsageName);
        if (!usage) return [];
    
        return this.configKeys.filter(k =>
            k.ConfigurationKeyUsagesId === usage.KeyUsageId &&
            k.DynamicForeignKey === dynamicForeignKey
        );
    }

    private updateSelectedNodes(): void {
        this.selectedNodeKeys = this.treeView.instance.getSelectedNodeKeys();
        this.selectedNodeCount = this.selectedNodeKeys.length;
    }

    onSelectionChanged(): void {
        const oldKeys = this.selectedNodeKeys;
        this.updateSelectedNodes();
        const newKeys = this.selectedNodeKeys;

        const selected = newKeys.filter(e => oldKeys.indexOf(e) < 0);
        if (selected.length) {
            this.onNodesSelected(selected);
        }

        const unselected = oldKeys.filter(e => newKeys.indexOf(e) < 0);
        if (unselected.length) {
            this.onNodesUnselected(unselected);
        }
    }

    private onNodesSelected(nodeKeys: any[]): void {
        const all = this.treeView.instance.getNodes();
        nodeKeys.forEach(key => {
            const node = this.findNode(all, key);
            if (node) {
                if (!this.isRootNode(node)) {
                    const parent = this.getParent(node);
                    if (!this.isRootNode(parent)) {
                        // This will generate a new event for the parent and that way it will
                        // iterate all the way to the top, excluding the very topmost node.
                        this.treeView.instance.selectItem(this.getKey(parent));
                    }
                }
            }
        });
    }

    private onNodesUnselected(nodeKeys: any[]): void {
        const all = this.treeView.instance.getNodes();
        nodeKeys.forEach(key => {
            const node = this.findNode(all, key);
            if (!this.isRootNode(node)) {
                this.unselectAllChildren(node);
            }
        });
    }

    private getKey(node: TreeViewItem): any {
        return (node as any)?.key;
    }

    private getParent(node: TreeViewItem): TreeViewItem {
        return (node as any)?.parent;
    }

    private isRootNode(node: TreeViewItem): boolean {
        return node && !this.getParent(node);
    }

    private unselectAllChildren(node: TreeViewItem): void {
        if (node?.items) {
            node.items.forEach(e => {
                this.treeView.instance.unselectItem(this.getKey(e));
                this.unselectAllChildren(e);
            });
        }
    }

    private findNode(nodes: TreeViewItem[], key: any): TreeViewItem | undefined {
        for (const node of nodes) {
            if (this.getKey(node) === key) {
                return node;
            }
            if (node.items && node.items.length > 0) {
                const found = this.findNode(node.items, key);
                if (found) {
                    return found;
                }
            }
        }
        return undefined;
    }

    getExportItems(): ExportItems {
        const items: ExportItems = {
            documentTypes: this.rootDocTypes.items.filter(e => e.selected).map((e: any) => e.exportNode),
            documentConfigurations: this.rootDocConfigs.items.filter(e => e.selected).map((e: any) => e.exportNode),
            trackingFields: this.rootTrackFields.items.filter(e => e.selected).map((e: any) => e.exportNode),
            configurationKeys: this.rootConfigKeys.items.filter(e => e.selected).map((e: any) => e.exportNode),
            itinerarySteps: this.rootItinerarySteps.items.filter(e => e.selected).map((e: any) => e.exportNode),
            initializeSteps: this.rootInitializeSteps.items.filter(e => e.selected).map((e: any) => e.exportNode),
            transportTypes: this.rootTransportTypes.items.filter(e => e.selected).map((e: any) => e.exportNode),
            exceptionTypes: this.rootErrorCodes.items.filter(e => e.selected).map((e: any) => e.exportNode),
            fileNamingTypes: this.rootFileNamingTypes.items.filter(e => e.selected).map((e: any) => e.exportNode),
            xmlArtifacts: this.rootXmlArtifacts.items.filter(e => e.selected).map((e: any) => e.exportNode),
            assemblyArtifacts: this.rootAssemblyArtifacts.items.filter(e => e.selected).map((e: any) => e.exportNode),
            promotionFilters: this.rootPromotionFilters.items.filter(e => e.selected).map((e: any) => e.exportNode),
            duplicateChecks: this.rootDuplicateChecks.items.filter(e => e.selected).map((e: any) => e.exportNode),
            contentTypeGroups: this.rootContentTypeGroups.items.filter(e => e.selected).map((e: any) => e.exportNode),
            documentTypeClassifierResolvers: this.rootDocumentTypeClassifierResolvers.items.filter(e => e.selected).map((e: any) => e.exportNode),
            documentTypeClassifiers: this.rootDocumentTypeClassifiers.items.filter(e => e.selected).map((e: any) => e.exportNode),
            batchingConfigurations: this.rootBatchingConfigurations.items.filter(e => e.selected).map((e: any) => e.exportNode),
            identificationTypes: this.rootIdentificationTypes.items.filter(e => e.selected).map((e: any) => e.exportNode),
        };
        this.treeView.instance.unselectAll();
        return items;
    }
}
